angular.module('ihestiaWidgets.dashboard')
  .directive('ihestiaDashboardModalsInjector', [function(){
    return {
      controller: 'ihestiaDashboardModalsInjectorCtrl',
      restrict: 'E',
      scope: true,
      templateUrl: 'ihestia-widgets-templates-app/dashboard/common/modalsInjector.tpl.html'
    };
  }]);